import { render, staticRenderFns } from "./legal-general.vue?vue&type=template&id=555ab39d&scoped=true&"
import script from "./legal-general.vue?vue&type=script&lang=js&"
export * from "./legal-general.vue?vue&type=script&lang=js&"
import style0 from "./legal-general.vue?vue&type=style&index=0&id=555ab39d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ab39d",
  null
  
)

export default component.exports